import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const DeleteIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M18.48,1.93h-4.04l-.07-.89c-.04-.59-.53-1.04-1.12-1.04h-6.51c-.59,0-1.08.45-1.12,1.04l-.07.89H1.52c-.53,0-.96.43-.96.96h0c0,.53.43.96.96.96h16.96c.53,0,.96-.43.96-.96h0c0-.53-.43-.96-.96-.96Z" />
  <path d="M1.67,4.58l1,13.68c.07.98.89,1.73,1.86,1.73h10.92c.98,0,1.79-.76,1.86-1.73l1-13.68H1.67ZM6.58,16.82s-.02,0-.03,0c-.22,0-.4-.17-.41-.39l-.55-8.58c-.01-.23.16-.42.39-.44.23-.01.42.16.44.39l.55,8.58c.01.23-.16.42-.39.44ZM10.41,16.41c0,.23-.18.41-.41.41s-.41-.18-.41-.41V7.83c0-.23.18-.41.41-.41s.41.18.41.41v8.58ZM14.4,7.85l-.55,8.58c-.01.22-.2.39-.41.39,0,0-.02,0-.03,0-.23-.01-.4-.21-.39-.44l.55-8.58c.01-.23.21-.4.44-.39.23.01.4.21.39.44Z" />
 </svg>,
 "Delete"
);
